import * as Yup from 'yup';
import { Rule, Operator } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Rule>().shape({
    assignee: Yup.object<Operator>().nullable().required(),
  });
}
